export const GET_BY_ID = 'events/getById';
export const GET_BY_ID_START = `${GET_BY_ID}_START`;
export const GET_BY_ID_SUCCESS = `${GET_BY_ID}_SUCCESS`;
export const GET_BY_ID_FAIL = `${GET_BY_ID}_FAIL`;

const uri = '/webapi/xm/1/events';

export const getById = ({ eventId, params }) => ({
  type: GET_BY_ID,
  meta: {
    xmApi: true,
    method: 'get',
    uri: `${uri}/${eventId}`,
    params,
  },
});
